import React from 'react';
import './ArticleFromServer.scss';
import './ArticleFromServer-media.scss';

const ArticleFromServer = ({ item }: { item: string }) => {
  return <div className="article-from-server" dangerouslySetInnerHTML={{ __html: item }}></div>;
};

export default ArticleFromServer;
